<article class="lk-detail">
  <header class="lk-detail__header">
    <span class="lk-detail__lock-chip">
      <i eIcon icon="lock" family="solid"></i>
      {{ t('detail.lockTitle', { gate: gate() }) }}
    </span>
    <div class="lk-detail__titles">
      <h3 class="lk-detail__role">
        {{ lockText('role') }}
        <span class="lk-detail__role-canonical">{{ lockText('roleCanonical') }}</span>
      </h3>
      <span class="lk-detail__group">{{ groupLabel() }}</span>
    </div>
  </header>

  <p class="lk-detail__theme">{{ lockText('theme') }}</p>

  @if (chartStatusLines().length > 0) {
    <section class="lk-detail__section lk-detail__chart-status">
      <h4>{{ t('detail.chartStatusTitle') }}</h4>
      <ul>
        @for (line of chartStatusLines(); track line.key) {
          <li [class.is-activated]="line.activated">
            <i eIcon [icon]="line.activated ? 'circle-check' : 'circle-xmark'" family="solid"></i>
            <span class="lk-detail__status-text">{{ line.text }}</span>
            @if (line.planetGlyphs.length > 0) {
              <span class="lk-detail__status-planets">
                @for (planet of line.planetGlyphs; track $index) {
                  <span class="lk-detail__status-planet" [style.color]="planet.color">{{ planet.glyph }}</span>
                }
              </span>
            }
          </li>
        }
      </ul>
    </section>
  }

  <section class="lk-detail__section">
    <h4>{{ t('detail.kernTitle') }}</h4>
    <p>{{ lockText('kern') }}</p>
  </section>

  <section class="lk-detail__section">
    <h4>{{ t('detail.keysTitle') }}</h4>
    <div class="lk-detail__keys">
      @for (key of keys(); track key.periodId) {
        <div class="lk-detail__key-card" [class.is-active]="key.isActivePeriod">
          <div class="lk-detail__key-head">
            <span class="lk-detail__key-chip">
              <i eIcon icon="key" family="solid"></i>
              {{ key.gate }}
            </span>
            <div class="lk-detail__key-titles">
              <span class="lk-detail__key-title">{{ key.title }} · {{ key.name }}</span>
              <span class="lk-detail__key-period">{{ key.periodLabel }}</span>
            </div>
          </div>
          <dl class="lk-detail__key-meta">
            <div>
              <dt>{{ t('detail.crossLabel') }}</dt>
              <dd>{{ key.cross }}</dd>
            </div>
            <div>
              <dt>{{ t('detail.circuitLabel') }}</dt>
              <dd>{{ key.circuit }}</dd>
            </div>
          </dl>
          <p class="lk-detail__key-description">{{ key.description }}</p>
          @if (key.planetaryNuance) {
            <p class="lk-detail__key-nuance">
              <strong>{{ t('detail.planetaryTitle') }}:</strong> {{ key.planetaryNuance }}
            </p>
          }
          @if (key.channelNote) {
            <p class="lk-detail__key-nuance">
              <strong>{{ t('detail.channelTitle') }}:</strong> {{ key.channelNote }}
            </p>
          }
          @if (key.starNote.length > 0) {
            <p class="lk-detail__key-nuance lk-detail__key-star-note">
              <strong>{{ t('detail.starNoteTitle') }}:</strong>
              @for (segment of key.starNote; track $index) {
                @if (segment.starSide != null) {
                  <button type="button" class="lk-detail__star-link"
                          (click)="openFixedStar(segment.starSide, $event)">{{ segment.text }}</button>
                } @else {
                  <span>{{ segment.text }}</span>
                }
              }
            </p>
          }
        </div>
      }
    </div>
  </section>

  <section class="lk-detail__section">
    <h4>{{ t('detail.shiftTitle') }}</h4>
    <p>{{ lockText('shift') }}</p>
  </section>

  <section class="lk-detail__section">
    <h4>{{ t('detail.impactTitle') }}</h4>
    <div class="lk-detail__impact">
      <div class="lk-detail__impact-block">
        <h5>{{ t('detail.humansLabel') }}</h5>
        <p>{{ lockText('impactHumans') }}</p>
      </div>
      <div class="lk-detail__impact-block">
        <h5>{{ t('detail.ravesLabel') }}</h5>
        <p>{{ lockText('impactRaves') }}</p>
      </div>
    </div>
  </section>

  <section class="lk-detail__section">
    <h4>{{ t('detail.analystTitle') }}</h4>
    <blockquote class="lk-detail__analyst">{{ lockText('analystNote') }}</blockquote>
  </section>
</article>
